export const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "-";
    return d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

export const formatTime = (time) => {
    if (!time) return "-";

    let d;
    if (time.includes("T")) {
        d = new Date(time);
    } else {
        const [hour, minute, second] = time.split(":").map(Number);
        d = new Date();
        d.setHours(hour || 0, minute || 0, second || 0);
    }

    if (isNaN(d.getTime())) return "-";

    return d.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
};

export const formatDateTime = (date, time) => {
    if (!date) return "-";
    return time
        ? `${formatDate(date)} | ${formatTime(time)}`
        : `${formatDate(date)} | -`;
};

export const getMeetingStatus = (date, time) => {
    if (!date || !time) return "NO_MEETING";
    const meetingDate = new Date(date);
    if (isNaN(meetingDate)) return "INVALID";
    let hours = 0;
    let minutes = 0;
    const timeStr = time.toLowerCase().trim();
    if (timeStr.includes("am") || timeStr.includes("pm")) {
        const [t, modifier] = timeStr.split(" ");
        let [h, m] = t.split(":").map(Number);
        if (modifier === "pm" && h !== 12) h += 12;
        if (modifier === "am" && h === 12) h = 0;
        hours = h;
        minutes = m;
    } else {
        [hours, minutes] = timeStr.split(":").map(Number);
    }
    meetingDate.setHours(hours, minutes, 0, 0);
    const now = new Date();
    if (now >= meetingDate) return "ENDED";
    const diffMinutes = (meetingDate - now) / 60000;
    if (diffMinutes > 60) return "COMING_SOON";
    return "ACTIVE";
};

export const normalizeTitle = (text = "") => {
    return text
        .replace(/\s+/g, " ")
        .replace(/\n/g, " ")
        .trim()
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase());
};

export const isSameDate = (d1, d2) =>
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();

export const isFutureDate = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date >= today;
};
